import { PropTypes } from '../propTypes/index.js';

// Based on https://github.com/gregberge/xstyled/blob/c0c92b459bb3a5de46d7854be3667861f816baa5/packages/prop-types/src/index.ts
const xstyledGenericPropType = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string,
  PropTypes.object,
  PropTypes.bool,
]);

const genericDescription = 'Applies to the root container. For more info read xstyled docs';

export const xstyledPropTypes = {
  margin: xstyledGenericPropType.description(genericDescription).xstyled(),
  m: xstyledGenericPropType.description(genericDescription).xstyled(),
  marginTop: xstyledGenericPropType.description(genericDescription).xstyled(),
  mt: xstyledGenericPropType.description(genericDescription).xstyled(),
  marginRight: xstyledGenericPropType.description(genericDescription).xstyled(),
  mr: xstyledGenericPropType.description(genericDescription).xstyled(),
  marginBottom: xstyledGenericPropType.description(genericDescription).xstyled(),
  mb: xstyledGenericPropType.description(genericDescription).xstyled(),
  marginLeft: xstyledGenericPropType.description(genericDescription).xstyled(),
  ml: xstyledGenericPropType.description(genericDescription).xstyled(),
  mx: xstyledGenericPropType.description(genericDescription).xstyled(),
  my: xstyledGenericPropType.description(genericDescription).xstyled(),
  padding: xstyledGenericPropType.description(genericDescription).xstyled(),
  p: xstyledGenericPropType.description(genericDescription).xstyled(),
  paddingTop: xstyledGenericPropType.description(genericDescription).xstyled(),
  pt: xstyledGenericPropType.description(genericDescription).xstyled(),
  paddingRight: xstyledGenericPropType.description(genericDescription).xstyled(),
  pr: xstyledGenericPropType.description(genericDescription).xstyled(),
  paddingBottom: xstyledGenericPropType.description(genericDescription).xstyled(),
  pb: xstyledGenericPropType.description(genericDescription).xstyled(),
  paddingLeft: xstyledGenericPropType.description(genericDescription).xstyled(),
  pl: xstyledGenericPropType.description(genericDescription).xstyled(),
  px: xstyledGenericPropType.description(genericDescription).xstyled(),
  py: xstyledGenericPropType.description(genericDescription).xstyled(),
  spaceY: xstyledGenericPropType.description(genericDescription).xstyled(),
  spaceX: xstyledGenericPropType.description(genericDescription).xstyled(),
  spaceXReverse: xstyledGenericPropType.description(genericDescription).xstyled(),
  spaceYReverse: xstyledGenericPropType.description(genericDescription).xstyled(),
  w: xstyledGenericPropType.description(genericDescription).xstyled(),
  width: xstyledGenericPropType.description(genericDescription).xstyled(),
  maxWidth: xstyledGenericPropType.description(genericDescription).xstyled(),
  maxW: xstyledGenericPropType.description(genericDescription).xstyled(),
  minWidth: xstyledGenericPropType.description(genericDescription).xstyled(),
  minW: xstyledGenericPropType.description(genericDescription).xstyled(),
  h: xstyledGenericPropType.description(genericDescription).xstyled(),
  height: xstyledGenericPropType.description(genericDescription).xstyled(),
  maxHeight: xstyledGenericPropType.description(genericDescription).xstyled(),
  maxH: xstyledGenericPropType.description(genericDescription).xstyled(),
  minHeight: xstyledGenericPropType.description(genericDescription).xstyled(),
  minH: xstyledGenericPropType.description(genericDescription).xstyled(),
  maskSize: xstyledGenericPropType.description(genericDescription).xstyled(),
  display: xstyledGenericPropType.description(genericDescription).xstyled(),
  float: xstyledGenericPropType.description(genericDescription).xstyled(),
  boxSizing: xstyledGenericPropType.description(genericDescription).xstyled(),
  container: xstyledGenericPropType.description(genericDescription).xstyled(),
  overflow: xstyledGenericPropType.description(genericDescription).xstyled(),
  overflowX: xstyledGenericPropType.description(genericDescription).xstyled(),
  overflowY: xstyledGenericPropType.description(genericDescription).xstyled(),
  zIndex: xstyledGenericPropType.description(genericDescription).xstyled(),
  position: xstyledGenericPropType.description(genericDescription).xstyled(),
  top: xstyledGenericPropType.description(genericDescription).xstyled(),
  right: xstyledGenericPropType.description(genericDescription).xstyled(),
  bottom: xstyledGenericPropType.description(genericDescription).xstyled(),
  left: xstyledGenericPropType.description(genericDescription).xstyled(),
  visibility: xstyledGenericPropType.description(genericDescription).xstyled(),
  overscrollBehavior: xstyledGenericPropType.description(genericDescription).xstyled(),
  objectFit: xstyledGenericPropType.description(genericDescription).xstyled(),
  color: xstyledGenericPropType.description(genericDescription).xstyled(),
  bg: xstyledGenericPropType.description(genericDescription).xstyled(),
  backgroundColor: xstyledGenericPropType.description(genericDescription).xstyled(),
  border: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderTop: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderBottom: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderRight: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderLeft: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderColor: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderTopColor: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderBottomColor: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderRightColor: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderLeftColor: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderStyle: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderTopStyle: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderBottomStyle: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderRightStyle: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderLeftStyle: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderWidth: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderTopWidth: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderBottomWidth: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderRightWidth: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderLeftWidth: xstyledGenericPropType.description(genericDescription).xstyled(),
  borderRadius: xstyledGenericPropType.description(genericDescription).xstyled(),
  boxShadow: xstyledGenericPropType.description(genericDescription).xstyled(),
};
